function getBannerList(state = [], action) {
    switch (action.type){
    case 'BANNER' :
        return action.data 
    default:
        return state
    }
}

export {getBannerList}